import React, { PureComponent } from "react";
import { Observer } from "mobx-react";
import {
  AutoSizer,
  CellMeasurerCache,
  IndexRange,
  InfiniteLoader,
  List,
  ListRowProps,
  OverscanIndexRange,
  WindowScroller
} from "react-virtualized";
import { Spinner } from "@components";
import { EmptyList } from "@search/SearchResult/EmptyList";
import { VirtualSearchManager } from "../VirtualSearchManager";

type Props = {
  renderRow: (params: ListRowProps) => React.ReactNode;
  scrollContainer: HTMLElement;
  cellMeasurerCache: CellMeasurerCache;
  manager: VirtualSearchManager<any>;
  onRowsRendered?: (params: IndexRange & OverscanIndexRange) => void;
  setListRef?: (listRef: List) => void;
};

class CardSearch extends PureComponent<Props> {
  listRef: List;
  windowScrollerRef: WindowScroller;

  constructor(props: Props) {
    super(props);
    this.props.manager.registerUpdateCallback(() => this.forceUpdate());
    this.props.manager.setScrollContainer(this.props.scrollContainer);
  }

  render() {
    const { cellMeasurerCache, manager } = this.props;

    return (
      <WindowScroller
        ref={(ref) => (this.windowScrollerRef = ref)}
        scrollElement={this.props.scrollContainer}
      >
        {(wsProps) => {
          if (typeof wsProps.height !== "number") {
            return null;
          }

          return (
            <InfiniteLoader
              ref={manager.setInfiniteLoaderRef}
              isRowLoaded={manager.isRowLoaded}
              loadMoreRows={manager.loadMoreRows}
              rowCount={10000}
              minimumBatchSize={30}
              threshold={10}
            >
              {({ onRowsRendered, registerChild }) => (
                <AutoSizer disableHeight>
                  {({ width }) => {
                    return (
                      <List
                        autoHeight
                        deferredMeasurementCache={cellMeasurerCache}
                        height={wsProps.height}
                        noRowsRenderer={this.renderEmpty}
                        onRowsRendered={(params) => {
                          this.props.onRowsRendered && this.props.onRowsRendered(params);
                          onRowsRendered(params);
                        }}
                        overscanRowCount={5}
                        ref={(ref) => {
                          if (ref) {
                            this.listRef = ref;
                            this.props.setListRef && this.props.setListRef(ref);
                            registerChild(ref);
                          }
                          // (wsProps as any).registerChild(ReactDOM.findDOMNode(ref));
                        }}
                        onScroll={wsProps.onChildScroll}
                        isScrolling={wsProps.isScrolling}
                        rowCount={manager.rowCount}
                        rowHeight={cellMeasurerCache.rowHeight}
                        rowRenderer={this.props.renderRow}
                        scrollTop={wsProps.scrollTop}
                        style={{ overflow: "hidden", outline: "none" }}
                        width={width}
                        containerStyle={{
                          padding: 16
                        }}
                      />
                    );
                  }}
                </AutoSizer>
              )}
            </InfiniteLoader>
          );
        }}
      </WindowScroller>
    );
  }

  renderEmpty = () => {
    const { manager } = this.props;
    return (
      <Observer>
        {() => (
          <div>
            {manager.isLoading && <Spinner />}
            {!manager.isLoading && <EmptyList />}
          </div>
        )}
      </Observer>
    );
  };
}

export default CardSearch;
